import React, { useEffect, useState, useRef } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { FaEye, FaEyeSlash } from "react-icons/fa";

import { addEditData } from "../../../controllers/cms/faqs";
import { fetchIpAddress } from "../../../controllers/API";

import LoadingEffect from "../../../components/Loading/LoadingEffect";
import { beforeUpload } from "../../../controllers/common";

const UserListEditPage = () => {
  const { Option } = Select;
  const { Dragger } = Upload;
  const targetRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);
  const [image, setImage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(["early", "primary", "middle", "senior","admission-process"]);

  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  const [pageAddEditData, setPageAddEditData] = useState([]);
  const handlePagesChange = (value) => {
    setPageAddEditData(value);
    setError((preError) => ({
      ...preError,
      page: "",
    }));
  };

  const pageOptions = pages.map((page) => ({
    value: page,
    label: page,
  }));


  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const {
        _id,
        title,
        description,
        sortno
      } = ADDEDITDATA;
      const ipAddress = (await fetchIpAddress()) || "0.0.0.0";

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("editId", _id);
      }
      form.append("title", title);
      form.append("description", description);
      form.append("page", pageAddEditData);
      form.append("sortno", sortno);
      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);
      if (isValidate) {
        const rawData = {
          editId : _id,
          title  : title,
          description : description,
          page : pageAddEditData,
          sortno : sortno,
          ipAddress : ipAddress,
        };
        const res = await addEditData(rawData);
        if (res.status === true) {
          notification.open({
            message: "Data added.",
            description: `Data added successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/cms/faq");
        } else {
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Opps!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };


  const validateFormData = (form) => {
    if (!form.get("title").trim() || form.get("title").trim() === "undefined" || form.get("title").trim() === null) {
      setError((preError) => ({
        ...preError,
        title: "Question is required",
      }));
      return false;
    }

    if (!form.get("description").trim() || form.get("description").trim() === "undefined" || form.get("description").trim() === null) {
      setError((preError) => ({
        ...preError,
        description: "Answer is required",
      }));
      return false;
    }

    if (!form.get("page") || form.get("page") === "undefined" || form.get("page") === null) {
      setError((preError) => ({
        ...preError,
        page: "Pages is required",
      }));
      return false;
    }
    if (!form.get("sortno") || form.get("sortno") === "undefined" || form.get("sortno") === null) {
      setError((preError) => ({
        ...preError,
        sortno: "Sort no. is required",
      }));
      return false;
    }
    return true;
  };




  useEffect(() => {
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    if(ADDEDITDATA?._id){
      setPageAddEditData(ADDEDITDATA?.page);
      // console.log(ADDEDITDATA?.page);
    }
    document.title = `KC High Admin || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } FAQ`;
  }, [ADDEDITDATA]);
  return (
    <div ref={targetRef}>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} FAQs
            </h5>
          </div>
          <Link to="/cms/faq">
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row inventory_form_main_content_form_section">
                  <div className="row">
                    <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="vendor_first_name"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>Question :{" "}
                      </label>
                      <input
                        title="Enter your Question"
                        placeholder="Enter your Question"
                        type="text"
                        name="title"
                        className="form-control store_input_field"
                        id="title"
                        value={ADDEDITDATA?.title}
                        onChange={handleChange}
                      />
                      {error.title ? (
                        <p style={{ color: "red" }}>
                          {error.title}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="description"
                        className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Answer :
                      </label>
                      <textarea
                        title="Enter your answer"
                        placeholder="Enter your answer"
                        type="text"
                        name="description"
                        className="form-control store_input_field"
                        id="description"
                        value={ADDEDITDATA?.description}
                        onChange={handleChange}
                        rows={5}
                      />
                      {error.description ? (
                        <p style={{ color: "red" }}>{error.description}</p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group col-lg-8 col-md-8 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="page" className="all_lebel_margin_top_main_div"><span style={{ color: "red" }}>*</span>Select pages : </label>
                      <Select
                        mode="multiple"
                        placeholder="Select pages"
                        variant="page"
                        name="page"
                        className="form-control store_input_field mt-2"
                        style={{ flex: 1 }}
                        value={pageAddEditData}
                        onChange={handlePagesChange}
                        options={pageOptions}
                      />
                      {error.page ? (
                        <p style={{ color: "red" }}>{error.page}</p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="sortno"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Sort no. :{" "}
                      </label>
                      <input
                        title="Enter Sort no."
                        placeholder="Enter Sort no."
                        type="number"
                        name="sortno"
                        className="form-control store_input_field"
                        id="sortno"
                        max={100}
                        value={ADDEDITDATA?.sortno}
                        onChange={handleChange}
                      />
                      {error.sortno ? (
                        <p style={{ color: "red" }}>
                          {error.sortno}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;
